package com.macrofocus.eflux.ui.layer

import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.deckgl.toJSonArray
import com.macrofocus.eflux.network.lightning.Lightning
import deckgl.ScatterplotLayer
import js.objects.unsafeJso
import mui.material.PaletteMode
import mui.material.styles.Palette
import mui.material.styles.Theme
import kotlin.math.absoluteValue

fun createLightningLayer(
    dataLoader: DataLoader,
    lightnings: Array<Lightning>?,
    cartographic: Double,
    theme: Theme,
    isCartographicZoomed: Boolean,
    isCartographic: Boolean
) : ScatterplotLayer<Lightning> {
    val array = if(lightnings != null) lightnings else emptyArray()

    return ScatterplotLayer<Lightning>(unsafeJso {
        id = "lightning-layer"

        visible = isCartographic

        this.data = array
//        opacity = 0.5 //if(isCartographicZoomed) 0.05 else 1.0
        asDynamic().positionFormat = "XY"
        getPosition = { d: Lightning ->
            d.geometry.toJSonArray()
        }
//        asDynamic().radiusUnits = "pixels"
        radiusScale = 10.0
        getRadius = { d: Lightning ->
            val strokeCurrent = d.strokeCurrent
            if(strokeCurrent != null && strokeCurrent != -999.0)
                strokeCurrent.absoluteValue
            else
                20.0
        }
        asDynamic().getFillColor = { d: Lightning ->
            if(theme.palette.unsafeCast<Palette>().mode == PaletteMode.light) {
                when (d.lightningType) {
                    // cloud-to-ground (CG)
                    1 -> arrayOf(255, 215, 0, 179)
                    // cloud-to-cloud (CC)
                    2 -> arrayOf(0, 191, 255, 128)
                    // intra-cloud (IC)
                    3 -> arrayOf(138, 43, 226, 77)
                    else -> arrayOf(255, 215, 0, 179)
                }
            } else {
                when (d.lightningType) {
                    // cloud-to-ground (CG)
                    1 -> arrayOf(255, 215, 0, 217)
                    // cloud-to-cloud (CC)
                    2 -> arrayOf(0, 191, 255, 166)
                    // intra-cloud (IC)
                    3 -> arrayOf(138, 43, 226, 115)
                    else -> arrayOf(255, 215, 0, 217)
                }
            }
        }
        asDynamic().stroked = true
        asDynamic().getLineColor = { d: Lightning ->
            if(theme.palette.unsafeCast<Palette>().mode == PaletteMode.light) {
                when (d.lightningType) {
                    // cloud-to-ground (CG)
                    1 -> arrayOf(139, 128, 0)
                    // cloud-to-cloud (CC)
                    2 -> arrayOf(0, 0, 139)
                    // intra-cloud (IC)
                    3 -> arrayOf(75, 0, 130)
                    else -> arrayOf(0, 0, 0)
                }
            } else {
                when (d.lightningType) {
                    // cloud-to-ground (CG)
                    1 -> arrayOf(139, 128, 0)
                    // cloud-to-cloud (CC)
                    2 -> arrayOf(0, 0, 139)
                    // intra-cloud (IC)
                    3 -> arrayOf(75, 0, 130)
                    else -> arrayOf(250, 250, 250)
                }
            }
        }
        asDynamic().getLineWidth = 1
        pickable = true
        autoHighlight = true
        highlightColor = if(isCartographicZoomed) arrayOf(255, 255, 255, 31) else arrayOf(255, 255, 255, 63)
        updateTriggers = unsafeJso {
            this.asDynamic().opacity = arrayOf(isCartographicZoomed)
            this.asDynamic().getFillColor = arrayOf(isCartographicZoomed, theme)
            this.asDynamic().getLineColor = arrayOf(isCartographicZoomed, theme)
            this.asDynamic().highlightColor = arrayOf(isCartographicZoomed)
        }
//        onHover = { info ->
//            val o = info.`object`
//            if (o != null) {
//                if (o is Lightning) {
//                    val schema = (o as Lightning)
//                    println(schema.toString())
////                    dataLoader.schemaProbing.selected = schema
//                } else {
////                    dataLoader.schemaProbing.clearSelection()
//                }
//            } else {
////                dataLoader.schemaProbing.clearSelection()
//            }
//        }
//        onClick = { info: dynamic ->
//            val o = info.`object`
//            if (o != null) {
//                if (o is Lightning) {
//                    val schema = (o as Lightning)
//                    println(schema.toString())
////                    dataLoader.schemaSelection.setSelectedElement(schema)
//                } else {
////                    dataLoader.schemaSelection.clearSelection()
//                }
//            } else {
////                dataLoader.schemaSelection.clearSelection()
//            }
//        }
//        asDynamic().getTooltip = tooltip
    })
}
